import React from "react";
import { Container, Paper } from "@mantine/core";

const TermsAndConditionsPage = () => {
  return (
    <Container size="md">
      <Paper padding="lg">
        <h1 style={{ textAlign: "center" }}>Terms and Conditions</h1>
        <p>
          Welcome to Data4Research! These Terms and Conditions outline the rules
          and regulations for the use of our data-donation service.
        </p>

        <h3>Acceptance of Terms</h3>
        <p>
          By using our data-donation service, you agree to comply with these
          Terms and Conditions. If you do not agree with any part of these
          terms, please do not use our service.
        </p>

        <h3>Use of the Service</h3>
        <p>
          Our data-donation service is intended for individuals above the age of
          18. By using our service, you confirm that you are at least 18 years
          old. If you are under 18, you must seek parental or guardian consent
          before using our service.
        </p>

        <h3>Data Donation</h3>
        <p>
          By donating your YouTube watch history and Chrome browsing history
          data through Google Takeout, you consent to the collection,
          anonymization, and use of this data for research purposes within the
          scope of our project. Please refer to our Privacy Policy for more
          information on how your data is handled and protected.
        </p>

        <h3>Intellectual Property</h3>
        <p>
          All content and materials on our data-donation service, including but
          not limited to text, graphics, logos, images, and software, are the
          property of Data4Research and are protected by applicable copyright,
          trademark, and intellectual property laws.
        </p>

        <h3>Liability</h3>
        <p>
          Data4Research and its affiliates, partners, and researchers will not
          be liable for any direct, indirect, incidental, special, or
          consequential damages resulting from the use or inability to use our
          data-donation service or any content or materials on our website.
        </p>

        <h3>Changes to the Terms and Conditions</h3>
        <p>
          Data4Research reserves the right to modify or replace these Terms and
          Conditions at any time without prior notice. Any changes will be
          effective immediately upon posting on our website. Your continued use
          of our service after the posting of any changes constitutes acceptance
          of those changes.
        </p>

        <h3>Contact Information</h3>
        <p>
          If you have any questions or concerns regarding these Terms and
          Conditions or our data-donation service, please feel free to contact
          us at [contact email/phone number]. We are here to provide any
          additional information you may need and address any concerns you may
          have.
        </p>
      </Paper>
    </Container>
  );
};

export default TermsAndConditionsPage;
